const defaultState = {
    searchReducer: {
        pageData: {},
        articleList:{},
        isEventTriggered: false,
        selectedEventSearchOption: "",
        searchOption:{
            "search_key": "",
            "search_value": "",
            "perpage": 10,
            "page": 1
        }
    },
    articleDetail:{
        pageData: {},
        article: {},
        accessLogResp: {}

    },
    connectint: {
        pageData: {},
        QuestionList: {}
    },
    auth:{
        isAppHeader: false,
        userID:''
    },
    nonSubscriber:{}
    

};
export default defaultState;